"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  control: function control(base) {
    return _objectSpread({}, base, {
      borderColor: _colors["default"].sterling,
      boxShadow: 'none',
      '&:hover': {
        borderColor: _colors["default"].blue
      }
    });
  },
  menu: function menu(base) {
    return _objectSpread({}, base, {
      marginTop: 0,
      maxHeight: 300
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread({}, base, {
      alignItems: 'center'
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base, {
      paddingRight: 10
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return _objectSpread({}, base, {
      display: 'none'
    });
  },
  option: function option(base, state) {
    return _objectSpread({}, base, {
      backgroundColor: state.isFocused ? _colors["default"].blue : _colors["default"].white,
      color: state.isFocused ? _colors["default"].white : _colors["default"].black,
      ':active': {
        backgroundColor: _colors["default"].ceruleanBlue,
        color: _colors["default"].white
      }
    });
  }
};
var _default = styles;
exports["default"] = _default;